var map = {
	"./account-ico-mail.svg": 501,
	"./account-ico-pass.svg": 502,
	"./account-ico-phone.svg": 503,
	"./bank-transfer.svg": 504,
	"./betnearn-ico.svg": 505,
	"./birthday-bonus-ico.svg": 506,
	"./birthday.webp": 1824,
	"./bonus-code-ico.svg": 507,
	"./bonus-ico.svg": 508,
	"./bonus-received-ico.svg": 509,
	"./bonus.webp": 1825,
	"./business-account-upgrade-ico.svg": 510,
	"./check-in-daily-ico.svg": 511,
	"./checked.svg": 512,
	"./cloud-pointer.svg": 513,
	"./crypto.svg": 514,
	"./daily-bonus-ico.svg": 515,
	"./daily-limit.webp": 1826,
	"./deposit-delay-bonus-ico.svg": 516,
	"./e-wallet.svg": 517,
	"./earn-coin-ico.svg": 518,
	"./earn-x33-coin-ico.svg": 519,
	"./email.svg": 520,
	"./facebook.svg": 521,
	"./feedback.svg": 522,
	"./first-bet-ico.svg": 523,
	"./games-rebate-ico.svg": 524,
	"./info.svg": 525,
	"./instagram.svg": 526,
	"./live-casino-rebate-ico.svg": 527,
	"./lucky-spin-ico.svg": 528,
	"./messenger.svg": 529,
	"./mobile-app-deposit-ico.svg": 530,
	"./monthly-cash.webp": 1827,
	"./msg-activity.svg": 531,
	"./msg-ann.svg": 532,
	"./msg-notice.svg": 533,
	"./new-icon.svg": 534,
	"./people-ico.svg": 535,
	"./quick-pay.svg": 536,
	"./rescue-bonus-ico.svg": 537,
	"./rescue-lc-ico.svg": 538,
	"./rescue-slots-ico.svg": 539,
	"./return.svg": 540,
	"./sc-bc-active-ico.svg": 541,
	"./sc-bc-ico.svg": 542,
	"./sc-bi-active-ico.svg": 543,
	"./sc-bi-ico.svg": 544,
	"./sc-mail-active-ico.svg": 545,
	"./sc-mail-ico.svg": 546,
	"./sc-mp-active-ico.svg": 547,
	"./sc-mp-ico.svg": 548,
	"./sc-pin-active-ico.svg": 549,
	"./sc-pin-ico.svg": 550,
	"./slots-rebate-ico.svg": 551,
	"./sports-rebate-ico.svg": 552,
	"./telegram.svg": 553,
	"./twitter.svg": 554,
	"./vip-up-level-ico.svg": 555,
	"./vip-weekly-bonus.svg": 556,
	"./wallet-ico.svg": 557,
	"./weekly-tournament-ico.svg": 558,
	"./welcome-bonus-ico.svg": 559,
	"./whatsapp.svg": 560,
	"./withdrawal-delay-bonus-ico.svg": 561,
	"./withdrawal.webp": 1828,
	"./x33-coin.svg": 562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;